import {
  CollectionTagEnum,
  TagConditionScope,
  TaskStatuses,
} from '@dynamika-shared/types/pmTaskDefinitions';

export const conditionOperators = [
  { value: '.And', label: 'And' },
  { value: '.Or', label: 'Or' },
  { value: '.Not', label: 'Not' },
  { value: '.Tag', label: 'Tag' },
];


export const taskStatusesOptions = [
  { value: TaskStatuses.CREATED, label: 'Created' },
  { value: TaskStatuses.PREPROCESSING_PENDING, label: 'Preprocessing Pending' },
  { value: TaskStatuses.READING_PENDING, label: 'Reading Pending' },
  { value: TaskStatuses.IN_PROGRESS, label: 'In Progress' },
  { value: TaskStatuses.COMPLETED, label: 'Completed' },
  { value: TaskStatuses.FAILED, label: 'Failed' },
  { value: TaskStatuses.TERMINATED, label: 'Terminated' },
];

export const taskTagType = [
  { value: '.TagIdStatus', label: 'Status' },
  { value: '.TagIdResultProperty', label: 'Status & Result' },
  { value: '.TagIdStatuses', label: 'Statuses' },
];

export const propertyOperatorOptions = [
  { value: '=', label: '=' },
  { value: '<', label: '<' },
  { value: '>', label: '>' },
  { value: '<=', label: '<=' },
  { value: '>=', label: '>=' },
  { value: '!=', label: '!=' },
];

export const TagConditionScopeLabels: Record<TagConditionScope, string> = {
  [TagConditionScope.PATIENT]: 'Patient',
  [TagConditionScope.ANY_VISIT]: 'Any Visit',
  [TagConditionScope.CURRENT_VISIT]: 'Current Visit',

  [TagConditionScope.PREVIOUS_VISIT]: 'Previous Visit',
  [TagConditionScope.ANY_PREVIOUS_VISITS]: 'Any Previous Visit',
  [TagConditionScope.ALL_PREVIOUS_VISITS]: 'All Previous Visits',
  [TagConditionScope.NONE_PREVIOUS_VISITS]: 'None of the Previous Visits',
  [TagConditionScope.ALL_PREVIOUS_VISITS_AND_CURRENT]: 'All Previous and Current Visit',

  [TagConditionScope.NEXT_VISIT]: 'Next Visit',
  [TagConditionScope.ANY_NEXT_VISITS]: 'Any Next Visit',
  [TagConditionScope.ALL_NEXT_VISITS]: 'All Next Visits',
  [TagConditionScope.NONE_NEXT_VISITS]: 'None of the Next Visits',
  [TagConditionScope.ALL_NEXT_VISITS_AND_CURRENT]: 'Current and All Next Visits',

  [TagConditionScope.ANY_INSCOPE_VISIT]: 'In-Scope - Any Visit',
  [TagConditionScope.ALL_INSCOPE_VISITS]: 'In-Scope - All Visits',
  [TagConditionScope.NONE_INSCOPE_VISITS]: 'In-Scope - None of the Visits',

  [TagConditionScope.INSCOPE_PREVIOUS_VISIT]: 'In-Scope - Previous Visit',
  [TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS]: 'In-Scope - All Previous Visits',
  [TagConditionScope.ANY_INSCOPE_PREVIOUS_VISITS]: 'In-Scope - Any Previous Visit',
  [TagConditionScope.NONE_INSCOPE_PREVIOUS_VISITS]: 'In-Scope - None of the Previous Visits',
  [TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS_AND_CURRENT]: 'In-Scope - All Previous and Current Visit',

  [TagConditionScope.INSCOPE_NEXT_VISIT]: 'In-Scope - Next Visit',
  [TagConditionScope.ALL_INSCOPE_NEXT_VISITS]: 'In-Scope - All Next Visits',
  [TagConditionScope.ANY_INSCOPE_NEXT_VISITS]: 'In-Scope - Any Next Visit',
  [TagConditionScope.NONE_INSCOPE_NEXT_VISITS]: 'In-Scope - None of the Next Visits',
  [TagConditionScope.ALL_INSCOPE_NEXT_VISITS_AND_CURRENT]: 'In-Scope - Current and All Next Visits',
};

export const tagConditionScopeOptions = [
  {
    label: 'Basic',
    options: [
      { value: TagConditionScope.PATIENT, label: TagConditionScopeLabels[TagConditionScope.PATIENT] },
      { value: TagConditionScope.CURRENT_VISIT, label: TagConditionScopeLabels[TagConditionScope.CURRENT_VISIT] },
      { value: TagConditionScope.ANY_VISIT, label: TagConditionScopeLabels[TagConditionScope.ANY_VISIT] },
    ],
  },
  {
    label: 'Previous Visits',
    options: [
      { value: TagConditionScope.PREVIOUS_VISIT, label: TagConditionScopeLabels[TagConditionScope.PREVIOUS_VISIT] },
      { value: TagConditionScope.ANY_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.ANY_PREVIOUS_VISITS] },
      { value: TagConditionScope.ALL_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.ALL_PREVIOUS_VISITS] },
      { value: TagConditionScope.NONE_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.NONE_PREVIOUS_VISITS] },
      { value: TagConditionScope.ALL_PREVIOUS_VISITS_AND_CURRENT, label: TagConditionScopeLabels[TagConditionScope.ALL_PREVIOUS_VISITS_AND_CURRENT] },
    ],
  },
  {
    label: 'Next Visits',
    options: [
      { value: TagConditionScope.NEXT_VISIT, label: TagConditionScopeLabels[TagConditionScope.NEXT_VISIT] },
      { value: TagConditionScope.ANY_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.ANY_NEXT_VISITS] },
      { value: TagConditionScope.ALL_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.ALL_NEXT_VISITS] },
      { value: TagConditionScope.NONE_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.NONE_NEXT_VISITS] },
      { value: TagConditionScope.ALL_NEXT_VISITS_AND_CURRENT, label: TagConditionScopeLabels[TagConditionScope.ALL_NEXT_VISITS_AND_CURRENT] },
    ],
  },
  {
    label: 'In-Scope',
    options: [
      { value: TagConditionScope.ANY_INSCOPE_VISIT, label: TagConditionScopeLabels[TagConditionScope.ANY_INSCOPE_VISIT] },
      { value: TagConditionScope.ALL_INSCOPE_VISITS, label: TagConditionScopeLabels[TagConditionScope.ALL_INSCOPE_VISITS] },
      { value: TagConditionScope.NONE_INSCOPE_VISITS, label: TagConditionScopeLabels[TagConditionScope.NONE_INSCOPE_VISITS] },
    ],
  },
  {
    label: 'In-Scope Previous Visits',
    options: [
      { value: TagConditionScope.INSCOPE_PREVIOUS_VISIT, label: TagConditionScopeLabels[TagConditionScope.INSCOPE_PREVIOUS_VISIT] },
      { value: TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS] },
      { value: TagConditionScope.ANY_INSCOPE_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.ANY_INSCOPE_PREVIOUS_VISITS] },
      { value: TagConditionScope.NONE_INSCOPE_PREVIOUS_VISITS, label: TagConditionScopeLabels[TagConditionScope.NONE_INSCOPE_PREVIOUS_VISITS] },
      { value: TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS_AND_CURRENT, label: TagConditionScopeLabels[TagConditionScope.ALL_INSCOPE_PREVIOUS_VISITS_AND_CURRENT] },
    ],
  },
  {
    label: 'In-Scope Next Visits',
    options: [
      { value: TagConditionScope.INSCOPE_NEXT_VISIT, label: TagConditionScopeLabels[TagConditionScope.INSCOPE_NEXT_VISIT] },
      { value: TagConditionScope.ALL_INSCOPE_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.ALL_INSCOPE_NEXT_VISITS] },
      { value: TagConditionScope.ANY_INSCOPE_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.ANY_INSCOPE_NEXT_VISITS] },
      { value: TagConditionScope.NONE_INSCOPE_NEXT_VISITS, label: TagConditionScopeLabels[TagConditionScope.NONE_INSCOPE_NEXT_VISITS] },
      { value: TagConditionScope.ALL_INSCOPE_NEXT_VISITS_AND_CURRENT, label: TagConditionScopeLabels[TagConditionScope.ALL_INSCOPE_NEXT_VISITS_AND_CURRENT] },
    ],
  },
];

// NOTE: typed as a total Record so that every CollectionTagEnum member is forced to
// declare a label here — `collectionTypeTagOptions` is derived from the enum keys, so a
// missing entry would silently render a blank option in the "Source" select.
export const CollectionTagTypeLabels: Record<CollectionTagEnum, string> = {
  [CollectionTagEnum.DXA]: 'DXA Label',
  [CollectionTagEnum.DICOM]: 'DICOM Label',
  [CollectionTagEnum.TASK]: 'Task result',
  [CollectionTagEnum.MEASUREMENT]: 'Measurement',
  [CollectionTagEnum.FILE]: 'File Label',
  [CollectionTagEnum.JSON]: 'JSON Label',
};

export const collectionTypeTagOptions = Object.keys(CollectionTagEnum).map(
  value => ({
    value,
    label: CollectionTagTypeLabels[value as keyof typeof CollectionTagEnum],
  })
);

export const taskSet = new Set(['TASK', 'MEASUREMENT']);

/**
 * Whether a source resolves against the study's labels.
 *
 * Plain terms
 * -----------
 * Some sources are a previous task's own result; the rest name a kind of data
 * the study collects, and those are the ones a condition can point at a label
 * for. Only the second group gets a label picker.
 *
 * Technical
 * ---------
 * The rule is the one documented on `CollectionTagEnum` in
 * `@dynamika-shared/types/pmTaskDefinitions`: every member outside `taskSet` is
 * resolved via `groupLabelsByFileType(labels)[collectionType]`. Testing
 * membership of `UploadFileTypeEnum` instead would silently exclude `FILE` and
 * `JSON` (D7-7610), whose pickers must still render — empty until the backend emits
 * labels with the matching `dataType` — so that an ANY/ALL comparison is never
 * bound to the single-label select.
 */
export const isLabelCollectionType = (collectionType?: string): boolean =>
  !!collectionType && !taskSet.has(collectionType);
